export default {
  pink: '#f64c75',
  green: '#2D9900',
  yellow: '#EAD300',
  red: '#9E0000',
  default: '#C1C1C1',
  primary: '#009A99',
  secondary: '#01bdbc',
  tertiary: '#F0F4FF',
};
